import { IdShowMeFeature } from "../features/show-me/IdShowMeFeature";
export var selectShowMe = function (state) { return state.showMe; };
export var selectShowMeTabId = function (state) {
    var showMeBuildingInfo = state.showMe[IdShowMeFeature.BuildingMenu];
    var isShowMeBuildingInfoRequired = showMeBuildingInfo && !showMeBuildingInfo.isConsumed;
    return isShowMeBuildingInfoRequired ? showMeBuildingInfo.tabId : undefined;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectShowMe.ts
// module id = 2573
// module chunks = 3